var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { debugLog } from "@lululemon/auth-common";
var TWO_MINUTES = 2 * 60 * 1000;
export function useUserActivity(_a) {
    var isEnabled = _a.isEnabled, onUserIdle = _a.onUserIdle, onUserActive = _a.onUserActive;
    var _b = __read(useState(true), 2), isUserActive = _b[0], setIsUserActive = _b[1];
    var _c = useIdleTimer({
        timeout: TWO_MINUTES,
        onIdle: function () {
            debugLog({ message: "User is idle." });
            setIsUserActive(false);
            if (typeof onUserIdle === "function") {
                onUserIdle();
            }
        },
        onActive: function () {
            debugLog({ message: "User is active." });
            setIsUserActive(true);
            if (typeof onUserActive === "function") {
                onUserActive();
            }
        },
        startManually: true
    }), pause = _c.pause, start = _c.start;
    // Manually enable idle timer based on LaunchDarkly flag
    useEffect(function () {
        if (isEnabled)
            start();
        return function () {
            pause();
        };
    }, [pause, isEnabled, start]);
    return { isUserActive: isUserActive };
}
